import React from "react";
import "./services.scss";
import SectionHeader from "../../components/section_header/SectionHeader";
import ServiceContainer from "../../components/service_container/ServiceContainer";
import { services } from "./servicesInfo";
const Services = () => {
  return (
    <div className="services_main">
      <SectionHeader name={"Services"} />
      <div className="services_contents">
        {services.map((item, index) => (
          <ServiceContainer key={index} serviceInfo={item} index={index} />
        ))}
      </div>
    </div>
  );
};

export default Services;
